export enum OrderState {
    Unknow,
    Incidence,
    Packed,
    Packing,
    Picked,
    Picking,
    OutOfPacking
}
